
import { createContext, useContext, useState, useEffect } from "react"
import { useAuth } from "./AuthContext"

const WalletContext = createContext()

export const useWallet = () => {
  const context = useContext(WalletContext)
  if (!context) {
    throw new Error("useWallet must be used within a WalletProvider")
  }
  return context
}

export const WalletProvider = ({ children }) => {
  const { user, setUser } = useAuth()
  const [transactions, setTransactions] = useState([])

  useEffect(() => {
    // Load transactions from localStorage
    const storedTransactions = localStorage.getItem("transactions")
    if (storedTransactions) {
      setTransactions(JSON.parse(storedTransactions))
    }
  }, [])

  const addTransaction = (transaction) => {
    const newTransaction = {
      id: Date.now(),
      date: new Date().toISOString(),
      ...transaction,
    }
    const updatedTransactions = [newTransaction, ...transactions]
    setTransactions(updatedTransactions)
    localStorage.setItem("transactions", JSON.stringify(updatedTransactions))
  }

  const deductBalance = (amount) => {
    if (user && user.balance >= amount) {
      const updatedUser = { ...user, balance: user.balance - amount }
      localStorage.setItem("user", JSON.stringify(updatedUser))
      return true
    }
    return false
  }

  const addBalance = (amount) => {
    if (user) {
      const updatedUser = { ...user, balance: user.balance + amount }
      localStorage.setItem("user", JSON.stringify(updatedUser))
    }
  }

  const value = {
    transactions,
    addTransaction,
    deductBalance,
    addBalance,
  }

  return <WalletContext.Provider value={value}>{children}</WalletContext.Provider>
}
